import { render, staticRenderFns } from "./ValuesPercentageDiff.vue?vue&type=template&id=3fbf57f6&scoped=true&"
import script from "./ValuesPercentageDiff.vue?vue&type=script&lang=js&"
export * from "./ValuesPercentageDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf57f6",
  null
  
)

export default component.exports